<script>
import formInput from "@/mixins/shared/formInput";

export default {
	mixins: [formInput],
	emits : ['delete'],
	computed: {
		previewUrl() {
			if (this.asset_id) {
				return route('api.v1.assets.preview', {asset: this.asset_id});
			}
			return 'about:blank';
		}
	},
	data() {
		return {
			showImage: false,
			showFile: false,
			asset : null
		}
	},
	watch: {
		modelValue: function (newValue, oldValue) {
			if (newValue && Object.keys(newValue).length == 0) {
				this.showImage = false;
				this.showFile = false;
				document.getElementById(this.renderedId).value = '';
				return;
			}
			if (newValue?.base64) {
				this.previewBase64(newValue);
			}
		},
		asset_id: function (newValue, oldValue) {
			this.previewAsset(newValue);
		}
	},
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'type': {
			type: String,
			default: 'text'
		},
		'label': {
			type: String,
			required: false
		},
		'asset_id': {
			type: Number,
			required: false
		},
		'showCamera' : {
			type: Boolean,
			required: false,
			default: false
		}
	},
	mounted() {
		if (this.modelValue?.base64) {
			this.previewBase64(this.modelValue);
			return;
		}
		this.previewAsset(this.asset_id);
	},
	methods: {
		isMobile()  {
			return /Mobi|Android/i.test(navigator.userAgent);
		},
		async convertToBase64(file) {
			return new Promise((resolve) => {
				const reader = new FileReader();
				reader.onloadend = () => {
					resolve(reader.result);
				};
				reader.readAsDataURL(file);
			});
		},
		async changeFile(e) {
			let file = e.target.files[0];
			let base64 = await this.convertToBase64(file)
			this.$refs.preview.setAttribute('src', base64);
			if (file.type.match('image')) {
				this.showImage = true;
				this.showFile = false;
			} else {
				this.showImage = false;
				this.showFile = true;
			}
			this.changeModelValueTo({
				name: file.name,
				type: file.type,
				size: file.size,
				lastModified: file.lastModified,
				base64: base64,
			})
		},
		openCamera() {
			// Open camera via input element
			const input = document.createElement('input');
			input.type = 'file';
			input.accept = 'image/*';
			input.multiple = false;
			input.onchange = (e) => this.changeFile(e);
			input.click();
		},
		// Toont de preview van een client-side vastgehouden bestand (base64), bijvoorbeeld
		// een asset die nog niet is opgeslagen
		previewBase64(file) {
			if ((file.type ?? '').match('image')) {
				this.showImage = true;
				this.showFile = false;
				// Na de render zetten, anders overschrijft de :src binding de preview weer
				this.$nextTick(() => this.$refs.preview?.setAttribute('src', file.base64));
			} else {
				this.showImage = false;
				this.showFile = true;
			}
		},

		async previewAsset(assetId) {
			// Een client-side vastgehouden bestand is actueler dan de opgeslagen asset
			if (this.modelValue?.base64) {
				return;
			}
			if (assetId > 0) {
				let asset = await Helpers.Ajax.get(route('api.v1.assets.show', {asset: assetId}), {}, {
					success: () => {
					}
				});
				this.asset = asset;
				if (asset.mimetype.match('image')) {
					this.showImage = true;
					this.showFile = false;
				} else {
					this.showImage = false;
					this.showFile = true;
				}
			} else {
				this.showImage = false;
				this.showFile = false;
			}
		}
	}
}
</script>

<template>
	<div v-show="showFile || showImage" class="w-100">
		<div class="d-flex gap-3 mb-3">
			<div class="flex-grow-1" v-show="showFile">
				<span v-if="form[name] && form[name].size > 0">
					<i class="bi-filetype-raw " style="color: #3f5d81"></i> {{form[name].name ?? this.asset?.orig_name}}
				</span>
				<a :href="previewUrl" v-else-if="this.asset?.id">
					<i class="bi-filetype-raw " style="color: #3f5d81"></i> {{ this.asset?.orig_name}}
				</a>
			</div>
			<div class="flex-grow-1" v-show="showImage">
				<img v-show="showImage" ref="preview" :src="previewUrl" style="max-width: 200px; max-height: 200px;"/>
			</div>
			<button
				class="btn btn-secondary align-self-start"
				type="button"
				@click="this.changeModelValueTo({})"
			>
				<i class="bi bi-trash"></i>
			</button>
		</div>
	</div>


	<div class="input-group">
		<span class="input-group-text" v-if="$slots.addonbefore">
			<slot name="addonbefore" />
		</span>
		<div class=" d-flex flex-grow-1">
			<input
				:name="name"
				v-bind="$attrs"
				@input="changeFile"
				type="file"
				:id="renderedId"
                :class="{'form-control': true, 'border-danger': hasError, 'rounded-start-0' : $slots.addonbefore, 'rounded-end-0' : $slots.addonafter}"
			>

		</div>
		<span class="input-group-text" v-if="isMobile() && this.showCamera">
            <button type="button" @click="openCamera" aria-label="Open camera">
    		    <i class="bi bi-camera"></i>
            </button>
		</span>
	</div>
	<div v-if="$slots.descriptionbottom" class="input-description mt-2">
		<slot name="descriptionbottom" />
	</div>
	<label v-if="hasError" class="text-danger mt-2 small">{{ this.form.errors[this.name] }}</label>
</template>
